import axios from '../../api/instance';

const namespace = 'referrals/';

const SET_REFERRALS = namespace + 'set_referrals';
const ADD_REFERRAL = namespace + 'add_referral';

export const FETCH_REFERRALS = namespace + 'fetch_referrals';
export const SUBMIT_REFERRAL = namespace + 'submit';
export const GET_REFERRALS = namespace + 'get_referrals';

// Referral states
export const REFERRAL_PENDING = 'pending';
export const REFERRAL_ACCEPTED = 'accepted';
export const REFERRAL_DISCOUNT_RECEIVED = 'discount_received';

export default {
    state: {
        referrals: [
            {
                email: 'user1@example.com',
                date: '17-08-2021 12:11',
                state: REFERRAL_PENDING,
            },
            {
                email: 'user2@example.com',
                date: '17-08-2021 12:11',
                state: REFERRAL_ACCEPTED,
            },
            {
                email: 'user5@example.com',
                date: '17-08-2021 12:11',
                state: REFERRAL_DISCOUNT_RECEIVED,
            },
        ],
    },
    mutations: {
        [SET_REFERRALS]: (state, referrals) => state.referrals = referrals,
        [ADD_REFERRAL]: (state, referral) => state.referrals.splice(0, 0, referral),
    },
    actions: {
        async [FETCH_REFERRALS]({commit}){
            let response = await axios.get('contact_persons/api/contact_persons/references');
            if (Array.isArray(response)){
                commit(SET_REFERRALS, response);
            } else {
                //added because codeignitor can give 200 codes while an error occured.
                commit(SET_REFERRALS, []);
                throw 'Response is not an array';
            }
        },
        async [SUBMIT_REFERRAL]({commit}, email){
            const payload = {
                email: email
            };
            let response = await axios.post('contact_persons/api/contact_persons/pre_reference', payload);
            commit(ADD_REFERRAL, response);
        },
    },
    getters: {
        [GET_REFERRALS]: (state) => state.referrals,
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/referrals.js